import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=eaf27a36"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"
import style0 from "./Review.vue?vue&type=style&index=0&id=eaf27a36&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eaf27a36')) {
      api.createRecord('eaf27a36', component.options)
    } else {
      api.reload('eaf27a36', component.options)
    }
    module.hot.accept("./Review.vue?vue&type=template&id=eaf27a36", function () {
      api.rerender('eaf27a36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/review/Review.vue"
export default component.exports